<template>
  <div>
    <div class="main-wrapper">
      <sidebar-component classMenu="salesProject"></sidebar-component>
      <div class="page-wrapper">
        <navbar-component></navbar-component>
        <!--begin::content-->
        <div class="page-content">
          <div
            class="d-flex justify-content-between align-items-center flex-wrap grid-margin"
          >
            <div>
              <h4 class="mb-12 mb-md-0"></h4>
            </div>

            <div class="col-lg-12 col-xl-12 stretch-card">
              <div class="card">
                <div class="card-header">
                  <h4 style="margin-right: 5px" class="float-start">
                    Sales Project Kickoff
                  </h4>
                  <button
                    :disabled="isLoading"
                    v-if="permision_role.method_upload"
                    class="btn btn-warning float-end btn-xs"
                    style="margin-right: 5px"
                    @click.prevent="uploadData()"
                  >
                    <i class="link-icon" data-feather="upload"></i>
                    {{ $t("uploadData") }} .xlsx
                  </button>
                  <button
                    :disabled="isLoading"
                    v-if="permision_role.method_read"
                    class="btn btn-success float-end btn-xs"
                    style="margin-right: 5px"
                    @click.prevent="downloadData()"
                  >
                    <i class="link-icon" data-feather="download"></i>
                    {{ $t("downloadData") }} .xlsx
                  </button>
                  <!-- <button
                    v-if="permision_role.method_upload"
                    class="btn btn-warning float-end btn-xs"
                    style="margin-right: 5px"
                    @click.prevent="uploadData()"
                  >
                    <i class="link-icon" data-feather="upload"></i>
                    {{ $t("uploadData") }} .xlsx
                  </button>
                  <button
                    v-if="permision_role.method_read"
                    class="btn btn-success float-end btn-xs"
                    style="margin-right: 5px"
                    @click.prevent="downloadData()"
                  >
                    <i class="link-icon" data-feather="download"></i>
                    {{ $t("downloadData") }} .xlsx
                  </button> -->
                </div>

                <div class="card-body">
                  <vue-good-table
                    mode="remote"
                    @on-page-change="onPageChange"
                    @on-sort-change="onSortChange"
                    @on-column-filter="onColumnFilter"
                    @on-per-page-change="onPerPageChange"
                    :totalRows="totalRecords"
                    :line-numbers="true"
                    :isLoading.sync="isLoading"
                    :pagination-options="{
                      enabled: true,
                    }"
                    :rows="rows"
                    :columns="columns"
                  >
                    <!-- <div slot="table-actions">
                      {{ $t("no_select_data") }}
                    </div>
                    <div slot="selected-row-actions">
                      <button
                      v-if="btnSendToRate"
                        class="btn btn-success btn-xs"
                        style="margin-right: 20px"
                        @click="sendToBlujay"
                      >
                        <i class="mdi mdi-send-outline"></i>Send To Billable
                        Rate
                      </button>
                      <span> </span>
                    </div> -->

                    <template slot="table-row" slot-scope="props">
                      <span v-if="props.column.field == 'actions'">
                        <a
                          href="#"
                          v-if="permision_role.method_read"
                          title="Detail"
                          @click.prevent="detailData(props.index, props.row)"
                        >
                          <i class="mdi mdi-eye" style="font-size: 16px"></i>
                        </a>
                        <!-- <a
                          href="#"
                          v-if="permision_role.method_update"
                          title="Edit"
                          @click.prevent="editData(props.index, props.row)"
                        >
                          <i
                            class="mdi mdi-square-edit-outline"
                            style="font-size: 16px"
                          ></i>
                        </a> -->
                      </span>
                      <span v-else>
                        {{ props.formattedRow[props.column.field] }}
                      </span>
                    </template>
                  </vue-good-table>
                </div>
              </div>
            </div>
            <modal-sales-project-edit
              :showModal="showModalSalesProjectEdit"
              :data="passData"
              @closeModal="closeMyModal"
            ></modal-sales-project-edit>
          </div>
        </div>
        <!--end::content-->
        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>

<script>
import sidebarComponent from "@/components/_partials/_sidebar";
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import modalSalesProjectEdit from "@/components/modal/modalSalesProjectEdit";
export default {
  name: "SalesProject",
  components: {
    "sidebar-component": sidebarComponent,
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
    "modal-sales-project-edit": modalSalesProjectEdit,
    //multiselect: multiselect,

    // DirectionsRenderer,
  },
  data() {
    return {
      maxToasts: 100,
      position: "up right",
      closeBtn: true,
      passData: "",
      isLoading: false,
      errors: [],
      permision_role: [],
      salesProjectIds:[],
      rowsSelection: [],
      langs: ["id", "en"],
      detailUser: [],
      detailDivisi: [],
      showModalSalesProjectEdit: false,
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {
          field: "updated_at",
          type: "desc",
        },
        page: 1,
        per_page: 10,
      },
      btnSendToRate: true,
      columns: [
        {
          label: "SOB",
          field: "sob_status",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By Status", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: "SAP Code",
          field: "sap_code",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By SAP Code", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: "Customer Code",
          field: "customer_code",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By Customer Code", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: "Customer Name",
          field: "customer_name",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By Customer Name", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: "Entries",
          field: "entries",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By Enteries", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: "Action",
          field: "actions",
          sortable: false,
        },
      ],
      rows: [],
    };
  },
  methods: {
    sendToBlujay() {},
    downloadData() {},
    closeMyModal() {
      this.showModalSalesProjectEdit = false;
      this.loadItems();
    },
    detailData(index, row) {
      if (row.customer_code !== "" && row.customer_code) {
        var params = this.$onRandom(row.sales_project_id);
        window.location.href = "/sales-project/detail/" + params;
      } else {
        this.$swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Company Code Empty, Please Edit First!",
        });
      }
    },
    editData(index, row) {
      this.passData = row.sales_project_id;
      this.showModalSalesProjectEdit = true;
    },
    // load items is what brings back the rows from server
    loadItems() {
      const baseURI = this.$settings.endPoint + "sales-project";
      //var columnFilters = this.serverParams.columnFilters;
      return this.$http
        .get(
          baseURI +
            `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&sob_status=${this.serverParams.columnFilters.sob_status}&sap_code=${this.serverParams.columnFilters.sap_code}&customer_code=${this.serverParams.columnFilters.customer_code}&customer_name=${this.serverParams.columnFilters.customer_name}&entries=${this.serverParams.columnFilters.entries}`
        )
        .then((response) => {
          this.rows = response.data.datas.data;
          this.totalRecords = response.data.datas.total;
        });
    },
    selectionChanged(ev) {
      this.rowsSelection = [];
      this.btnSendToRate = true;
      this.rowsSelection = ev.selectedRows;
      this.salesProjectIds = [];
      this.rowsSelection.forEach((item) => {
        if (item.customer_code == "") {
          this.btnSendToRate = false;
        }
        this.salesProjectIds.push(item.sales_project_id);
      });
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
      this.loadItems();
    },
    onColumnFilter(params) {
      params.page = 1;
      this.updateParams(params);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
    },

    onSortChange(params) {
      this.updateParams({
        sort: {
          type: params[0].type,
          field: params[0].field,
        },
      });
    },

    onPerPageChange(params) {
      this.updateParams({ per_page: params.currentPerPage });
    },
    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.isLoading = false;
      }, 1000); // hide the message after 3 seconds
    },

    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (permision.permission.controller == "SalesProjectController") {
          rolePermision = permision;
          // console.log(permision);
        }
      });

      if (!rolePermision.method_read) {
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;
    },
  },
  mounted() {
    this.fetchIt();
    this.loading();
  },
};
</script>

<style></style>
